import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';
// import Link from 'components/link';

import 'styles/domik/section-terms/_page-terms.scss';

const bemClasses = new Bem('pageTerms');

export default class DocCookieAgreement extends Component {
  static propTypes = {
    blockRef: PropTypes.func,
    blockId: PropTypes.string
  };

  render() {
    const { blockRef, blockId } = this.props;

    return (
      <div
        {...bemClasses('section', 'cookieAgreement')}
        ref={blockRef}
        id={blockId}
      >
        <Trans lang="ru">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Соглашение об использовании cookie-файлов" />
              </div>
            </Col>
          </Row>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Общие сведения" />
              <div {...bemClasses('text')}>
                <p children="На Сайте Домик применяется технология сбора информации с использованием cookie-файлов, которая позволяет повысить эффективность Сайта. Сookie-файлы — это маленькие текстовые файлы, которые размещаются на устройстве пользователя веб-сайтами, которые посещались пользователем. Они широко используются для того, чтобы веб-сайты могли работать эффективнее, а также, чтобы предоставлять необходимую информацию администрации веб-сайта. Использование cookie-файлов ー стандартная практика для большинства веб-сайтов. Посещая Домик пользователь соглашается с условиями использования cookie-файлов, которые описаны в настоящем документе, в том числе с тем, что ЧП «РА» ДОМИК НЕТ» юр. адрес: 04210, г. Киев, Оболонский р-н, пр. Героев Сталинграда, 6б, кор. 3, оф.1, код ЕГРПОУ 36080646, может использовать cookie-файлы и иные данные для их последующей обработки, а также может передавать их третьим лицам для проведения исследований и предоставления услуг." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Цели использования cookie-файлов" />
              <div {...bemClasses('text')}>
                <p children="Целями использования cookie-файлов на Домике являются:" />
              </div>
              <ul {...bemClasses('ul', 'disc')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="повышение удобства использования Домиком;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="персонализация взаимодействия;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="оптимизация сервисов, услуг на Домике в соответствии с интересами и потребностями пользователей;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="создание профилей пользователей;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="идентификация пользователей;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="оценка эффективности рекламных кампаний." />
                </li>
              </ul>
              <div {...bemClasses('text')}>
                <p children="Для достижения указанных целей, собираемые данные могут передаваться Партнерам Домика, которые оказывают нам помощь в предоставлении услуг. К категориям таких получателей относятся: веб-аналитика, обработка данных, реклама и др." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Прекращение использования cookie-файлов" />
              <div {...bemClasses('text')}>
                <p children="На Домике используются cookie-файлы двух разных типов:" />
              </div>
              <ul {...bemClasses('ul', 'disc')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="сеансовые cookie-файлы. Это временные файлы cookie, которые хранятся на устройстве пользователя до того момента, когда пользователь покидает Сайт;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="постоянные cookie-файлы. Эти cookie-файлы остаются на устройстве пользователя на длительный срок или вплоть до момента их ручного удаления." />
                </li>
              </ul>
              <div {...bemClasses('text')}>
                <p children="Прекращение использования cookie-файлов Домиком возможно путем:" />
              </div>
              <ul {...bemClasses('ul', 'disc')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="отключения использования cookie-файлов в настройках веб-браузера;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="отказа от использования Домика." />
                </li>
              </ul>
              <div {...bemClasses('text')}>
                <p children="Отключение используемых Домиком cookie-файлов может привести к снижению удобства использования. Большинство браузеров позволяют просматривать, удалять и блокировать cookie-файлы c веб-сайтов. Информация по управлению cookie-файлами может быть найдена в документации на используемый браузер." />
              </div>
            </li>
          </ol>
        </Trans>
        <Trans lang="ua">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Угода про використання cookie-файлів" />
              </div>
            </Col>
          </Row>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Загальні відомості" />
              <div {...bemClasses('text')}>
                <p children="На Сайті Домік застосовується технологія збору інформації з використанням cookie-файлів, яка дозволяє підвищити ефективність Сайту. Сookie-файли ー це маленькі текстові файли, які розміщуються на пристрої користувача веб-сайтами, які відвідувалися користувачем. Вони широко використовуються для того, щоб веб-сайти могли працювати ефективніше, а також, щоб надавати необхідну інформацію адміністрації веб-сайту. Використання cookie-файлів ー стандартна практика для більшості веб-сайтів. Відвідуючи Домік користувач погоджується з умовами використання cookie-файлів, які описані в цьому документі, в тому числі з тим, що ПП «РА ДОМІК НЕТ» юр. адреса: 04210, м. Київ, Оболонський р-н, пр-т Героїв Сталінграда, 6б, кор. 3, оф.1, ЄДРПОУ 36080646 може використовувати cookie-файли та інші дані для їхньої подальшої обробки, а також може передавати їх третім особам для проведення досліджень і надання послуг." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Цілі використання cookie-файлів" />
              <div {...bemClasses('text')}>
                <p children="Цілями використання cookie-файлів на Доміку є:" />
              </div>
              <ul {...bemClasses('ul', 'disc')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="підвищення зручності користування Доміком;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="персоналізація взаємодії;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="оптимізація сервісів, послуг на Доміку відповідно до інтересів і потреб користувачів;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="створення профілів користувачів;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="ідентифікація користувачів;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="оцінка ефективності рекламних кампаній." />
                </li>
              </ul>
              <div {...bemClasses('text')}>
                <p children="Для досягнення зазначених цілей, дані, які збираються можуть передаватися Партнерам Доміка, які нам допомагають в наданні послуг. До категорій таких одержувачів відносяться: веб-аналітика, обробка даних, реклама та ін." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Припинення використання cookie-файлів" />
              <div {...bemClasses('text')}>
                <p children="На Доміку використовуються cookie-файли двох різних типів:" />
              </div>
              <ul {...bemClasses('ul', 'disc')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="сеансові cookie-файли. Це тимчасові файли cookie, які зберігаються на пристрої користувача до того моменту, коли користувач залишає Сайт;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="постійні cookie-файли. Ці cookie-файли залишаються на пристрої користувача на тривалий термін або аж до моменту їхнього ручного видалення." />
                </li>
              </ul>
              <div {...bemClasses('text')}>
                <p children="Припинення використання cookie-файлів Доміком можливе шляхом:" />
              </div>
              <ul {...bemClasses('ul', 'disc')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="відключення використання cookie-файлів у налаштуваннях веб-браузера;" />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="відмови від використання Доміком." />
                </li>
              </ul>
              <div {...bemClasses('text')}>
                <p children="Відключення Доміком cookie-файлів, які використовувались, може призвести до зниження зручності використання. Більшість браузерів дозволяють переглядати, видаляти і блокувати cookie-файли c веб-сайтів. Інформація по управлінню cookie-файлами може бути знайдена в документації на браузер, який використовувався." />
              </div>
            </li>
          </ol>
        </Trans>
      </div>
    );
  }
}
